// @flow
import styles from './DashboardError.less';

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { ErrorIcon, Text } from 'seek-style-guide/react';
import { retryDashboard } from 'src/store/dashboard/dashboard';

const mapDispatchToProps = dispatch => ({
  retryHandler: () => dispatch(retryDashboard())
});

type Props = {
  message?: string,
  retryHandler?: Function
};

class DashboardError extends PureComponent<Props> {
  static defaultProps = {
    message: '',
    retryHandler: () => {}
  };

  render() {
    const { retryHandler } = this.props;

    return (
      <div className={styles.root} data-automation="dashboardError">
        <div className={styles.messageContainer}>
          <ErrorIcon svgClassName={styles.errorSvg} />
          <Text subheading regular raw secondary baseline={false}>
            Sorry, your dashboard is currently unavailable.
            <span className={styles.retry} onClick={retryHandler}>
              Try again
            </span>
          </Text>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(DashboardError);
